import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import CardListSection from './CardListSection';

class CardList extends Component {
  render() {
    const {
      title,
      children,
      onClick,
      onKeyPress,
      className,
    } = this.props;
    const childrenArray = (children && Array.isArray(children)) ? children : [children];
    return (
      <div className="CardList" role="list">
        {title ? <div className="CardList_Title">{title}</div> : null}
        {
          childrenArray.map((value, index) => {
            const isSection = value && value.type === CardListSection;
            const selectable = !isSection && (onClick || onKeyPress);
            const onClickActions = selectable ? {
              onClick: (e) => { onClick(e, index); },
              onKeyPress: (e) => { onKeyPress(e, index); },
              tabIndex: 0,
            } : { };
            return (
              <div
                className={classnames('CardList_Item', { CardList_Select: selectable }, className)}
                role="listitem"
                key={index}
                {...onClickActions}
              >
                {value}
              </div>
            );
          })
        }
      </div>
    );
  }
}

CardList.Section = CardListSection;

CardList.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  className: PropTypes.string,
};

CardList.defaultProps = {
  className: '',
  children: null,
  onClick: null,
  onKeyPress: null,
  title: null,
};

export default CardList;
